module.exports = __webpack_public_path__ + "media/images/icons/truck-e1ffa48a93086fa7130f746e43a250b7.svg";